import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DropZone } from 'foundations-components/transitional/components/DropZone';
import { Text } from 'foundations-components/components/Text';
// @ts-ignore not typed yet
import AfterBeginPortal from 'ContentEditorUI/components/portals/AfterBeginPortal';
// @ts-ignore not typed yet
import { getRowInnerWrapperElement } from 'ContentEditorUI/lib/layoutSection/dom';
import { EMPTY_PLACEHOLDER_ID_PARTIAL } from 'layout-dnd-utils/constants/dndAreaDomConstants';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
// @ts-ignore not typed yet
import { getDndAreaElementForNode } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default class LayoutSectionEmptyRowPlaceholder extends Component {
  componentDidMount() {
    const {
      row
    } = this.props;
    this.getRowFromDOM(row);
  }
  componentDidUpdate(prevProps) {
    const {
      row
    } = this.props;
    if (prevProps.row !== row) {
      this.getRowFromDOM(row);
    }
  }
  componentWillUnmount() {
    this.rowChildElement = undefined;
  }
  getRowFromDOM(row) {
    const rowElement = getDndAreaElementForNode(row);
    if (rowElement) {
      this.rowChildElement = getRowInnerWrapperElement(rowElement);
    }
    return this.rowChildElement;
  }
  render() {
    const {
      row,
      isHovered
    } = this.props;

    // After a tree structure change we expect that the DOM may not have been updated yet.
    // So try again if needed, but bail silently if the DOM is still missing
    if (!this.rowChildElement && !this.getRowFromDOM(row)) {
      return null;
    }
    return /*#__PURE__*/_jsx(AfterBeginPortal, {
      id: `${EMPTY_PLACEHOLDER_ID_PARTIAL}-row-${row.getName()}`,
      namespace: NAMESPACE_CLASS,
      targetElement: this.rowChildElement,
      children: /*#__PURE__*/_jsx(DropZone, {
        size: "small",
        use: isHovered ? 'hover' : 'default',
        margin: "100",
        children: /*#__PURE__*/_jsx(Text, {
          color: "icon-core-subtle",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.layoutSection.dropZone"
          })
        })
      })
    });
  }
}